<template>

  <div>
    <b-form-group label="Merk" label-class="font-weight-bold">
      <b-checkbox v-model="writeBrand">Overschrijven</b-checkbox>
      <b-select :options="brands.nodes" v-model="brand"/>
    </b-form-group>

    <b-form-group label="Naam" label-class="font-weight-bold">
      <b-checkbox v-model="writeName">Overschrijven</b-checkbox>
      <b-input v-model="name"/>
    </b-form-group>

    <b-form-group label="SNMP naam" label-class="font-weight-bold">
      <b-checkbox v-model="writeSnmpName">Overschrijven</b-checkbox>
      <b-input v-model="snmpName"/>
    </b-form-group>

    <b-form-group label="Profiel" label-class="font-weight-bold">
      <b-checkbox v-model="writeProfile">Overschrijven</b-checkbox>
      <b-select :options="profiles.nodes" text-field="name" value-field="id" v-model="profile" />
    </b-form-group>

  </div>

</template>

<script>

import {CACHE_AND_NETWORK} from '@/lib/constants';

export default
{
    apollo:
    {
        brands:
        {
            query: require('../graphql/query/brands_dropdown.gql')
        },
        profiles:
        {
            query: require('../graphql/list_profiles.gql'),
            fetchPolicy: CACHE_AND_NETWORK
        }
    },
    data()
    {
        return {
            brands: { nodes: [] },
            profiles: { nodes: [] },
            // Input fields
            writeBrand: false,
            writeName: false,
            writeProfile: false,
            writeSnmpName: false,
            brand: null,
            name: null,
            profile: null,
            snmpName: null
        }
    },
    methods:
    {
        async save(ok)
        {
            const input =
                {
                    ids: this.ids,
                    patch:
                    {
                        brand:    this.writeBrand ? this.brand : null,
                        name:     this.writeName ? this.name : null,
                        profile:  this.writeProfile ? this.profile : null,
                        snmpName: this.writeSnmpName ? this.snmpName : null
                    }
                }

            await this.$apollo.mutate(
                {
                    mutation: require('../graphql/mutation/mass_update_models.gql'),
                    variables: {input}
                }
            );

            ok();
        }
    },
    props:
    {
        ids: { type: Array }
    }
}
</script>

<style>
</style>